export enum ReportsFilterType {
    String = 'stringFilter',
    Number = 'numberFilter',
    Date = 'dateFilter',
}